import { render, staticRenderFns } from "./AdminHeaderModule.vue?vue&type=template&id=01ba181c&scoped=true"
import script from "./AdminHeaderModule.vue?vue&type=script&lang=js"
export * from "./AdminHeaderModule.vue?vue&type=script&lang=js"
import style0 from "./AdminHeaderModule.vue?vue&type=style&index=0&id=01ba181c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba181c",
  null
  
)

export default component.exports